(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const footerMenuTitles = document.querySelectorAll('[data-menu-toggle]');

    footerMenuTitles.forEach(function (title) {
      title.addEventListener('click', function () {
        // 只在移动端执行
        if (window.innerWidth <= 768) {
          const column = this.closest('.footer-menu-column');
          const isActive = column.classList.contains('active');

          // 关闭所有其他的菜单
          document.querySelectorAll('.footer-menu-column.active').forEach(function (activeColumn) {
            if (activeColumn !== column) {
              activeColumn.classList.remove('active');
            }
          });

          // 切换当前菜单状态
          if (isActive) {
            column.classList.remove('active');
          } else {
            column.classList.add('active');
          }
        }
      });
    });

    // 监听窗口大小变化，在桌面端时移除所有active状态
    window.addEventListener('resize', function () {
      if (window.innerWidth > 768) {
        document.querySelectorAll('.footer-menu-column.active').forEach(function (column) {
          column.classList.remove('active');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
